<template>
    <a-card type="inner" size="small" :bordered="!inHeader">
        <a-row type="flex" >
            <a-col :span="24" :gutter="[0,0]">
                <a-descriptions bordered>
                    <a-descriptions-item label="Nama Pelatihan">
                        <strong>{{ trainingInfo.title }}</strong>
                    </a-descriptions-item>
                    <a-descriptions-item label="Tanggal Pelatihan">
                        <strong>{{ moment(trainingInfo.date_start).format('DD MMMM YYYY') }} s.d {{ moment(trainingInfo.date_end).format('DD MMMM YYYY') }}</strong>
                    </a-descriptions-item>
                    <a-descriptions-item label="Deskripsi">
                        <strong>{{ trainingInfo.description }}</strong>
                    </a-descriptions-item>
                    <a-descriptions-item label="Lokasi" :span="2" v-if="withLocation">
                        <strong>{{ trainingInfo.location }}</strong>
                    </a-descriptions-item>
                </a-descriptions>
            </a-col>
        </a-row>

        <common-user-header :user_hash="user_hash" v-if="withUser" :penilai="penilai" style="margin-top: 24px" />
    </a-card>
</template>

<script>
export default {
    props: {
        user_hash: {
            type: String,
            required: false,
            default: null
        },
        withUser: {
            type: Boolean,
            default: false
        },
        penilai: {
            type: Number,
            default: 0
        },
        inHeader: {
            type: Boolean,
            default: false
        },
        withLocation: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        trainingInfo(){
            return this.$laravel.training
        }
    }
}
</script>
